{
  "%1$s/%2$s": "%1$s/%2$s",
  "%d%s": "%d%s",
  "%d℃": "%d℃",
  "%d℉": "%d℉",
  "%s %,.2f": "%s %,.2f",
  "%s %.2f": "%s %.2f",
  "%s %s": "%s %s",
  "%s - %s": "%s - %s",
  "%s - %s | %s": "%s - %s | %s",
  "%s, %s": "%s, %s",
  "%s, %s, %s": "%s, %s, %s",
  "%s, %s, %s, %s": "%s, %s, %s, %s",
  "(Excluding your carry-on baggage)": "(باستثناء حقائب اليد)",
  "(Optional)": "(إختياري)",
  "+ %s %,.2f": "+ %s %,.2f",
  "+ Add New Address": "+ إضافة عنوان جديد",
  "+ New Address": "+ عنوان جديد ",
  "AD": "أندورا",
  "AE": "الإمارات العربية المتحدة",
  "AF": "أفغانستان",
  "AG": "أنتيغوا وباربودا",
  "AGE_REQUIREMENT": "يجب أن يكون عمرك على الأقل {{requiredAge}} سنة لإنشاء حساب.",
  "AI": "أنغويلا",
  "AL": "ألبانيا",
  "AM": "أرمينيا",
  "AO": "أنغولا",
  "AQ": "أنتاركتيكا",
  "AR": "الأرجنتين",
  "AS": "ساموا الأمريكية",
  "AT": "النمسا",
  "AU": "أستراليا",
  "AW": "أروبا",
  "AZ": "أذربيجان",
  "Active": "قيد التنفيذ",
  "Analytics": "التحليلات",
  "Active bookings": "حجوزات قيد التنفيذ",
  "Add": "اضف",
  "Add Address": "إختر موقع الإستلام",
  "Add Bag": "إضافة حقيبة",
  "Add Bag Details": "تفاصيل الحقيبة",
  "Add Bags": "أضف الأمتعة",
  "Add Bags Details Later": "أضف تفاصيل الحقائب لاحقًا",
  "Add E-Ticket Number or Booking Reference Number": "أضف رقم التذكرة الإلكترونية أو الرقم المرجعي للحجز",
  "Add E-Ticket Number or Booking Reference Number *": "أضف رقم التذكرة الإلكترونية أو الرقم المرجعي للحجز *",
  "Add address": "إضافة عنوان",
  "Add new address": "إضافة عنوان جديد",
  "Add your dropoff location": "أضف موقع التسليم",
  "Add your pickup location": "أضف موقع الاستلام",
  "Added Bags": "الحقائب المضافة",
  "Address Added": "تم إضافة العنوان",
  "Address Added Successfully": "تم اضافة العنوان بنجاح",
  "Address Book": "دفتر العناوين",
  "Address Name": "اسم الموقع",
  "Address Updated Successfully": "تم تعديل العنوان بنجاح",
  "Address Type": "نوع العنوان",
  "Address type": "نوع العنوان",
  "Agent Name": "إسم السائق",
  "Airline logo": "شعار شركة الطيران",
  "Airport": "المطار",
  "Airport To Door": "من المطار إلى الباب",
  "Airport-To-Door - Arrival Service": "من المطار إلى الباب - خدمة الوصول",
  "Actions": "الإجراءات",
  "All": "الكل",
  "All Bookings": "جميع الحجوزات",
  "Almost there! this step is really important": "أوشكنا على الانتهاء! هذه الخطوة مهمة جداً",
  "Almost there…": "على بعد خطوة واحدة…",
  "Amount": "المبلغ",
  "Amount due": "المبلغ المستحق",
  "Amount To Be Paid:": "المبلغ الواجب دفعه:",
  "Amount:": "المبلغ:",
  "An OTP has been sent to": "تم إرسال رمز التحقق إلى",
  "Anything else you would like us to know?": "أي شيء آخر كنت تريدنا لنا أن نعرف؟",
  "Apartment": "شقة",
  "Apartment Name or Number": "اسم أو رقم الشقة",
  "Arabic": "العربية",
  "Are you sure you want to cancel this booking?": "هل أنت متأكد أنك تريد إلغاء هذا الحجز؟",
  "Are you sure you want to change your booking service?": "هل أنت متأكد أنك تريد تغيير خدمة الحجز الخاصة بك؟",
  "Are you sure you want to delete the following address?": "هل أنت متأكد انك تريد حذف هذا العنوان؟",
  "Are you sure you want to end booking process?": "هل انت متاكد من انك تريد انهاء الحجز",
  "Additional Baggage": "أمتعة إضافية",
  "Additional amount": "المبلغ الإضافي",
  "Additional bags": "حقائب إضافية",
  "Additional baggage was not added": "لم تتم إضافة الأمتعة الإضافية",
  "Area": "المنطقة",
  "Area:": "المنطقة: ",
  "Arrival Airport": "مطار الوصول",
  "At Airport": "في المطار",
  "At Checkout": "في الدفع",
  "Attention! The flow will be ended, you will loose all the information added": "الرجاء الانتباه العملية ستنتهي و كل المعلومات المدخلة ستختفي",
  "BA": "البوسنة والهرسك",
  "BACK": "ارجع",
  "BB": "بربادوس",
  "BD": "بنغلاديش",
  "BE": "بلجيكا",
  "BF": "بوركينا فاسو",
  "BG": "بلغاريا",
  "BH": "البحرين",
  "BI": "بوروندي",
  "BJ": "بنين",
  "BL": "سان بارتيلمي",
  "BM": "برمودا",
  "BN": "بروناي دار السلام",
  "BO": "بوليفيا",
  "BOOKING ID=": "رقم الحجز=",
  "BR": "البرازيل",
  "BS": "البهاما",
  "BT": "بوتان",
  "BV": "جزيرة بوفيت",
  "BW": "بوتسوانا",
  "BY": "بيلاروسيا",
  "BZ": "بليز",
  "Back": "الرجوع للخلف",
  "Back to booking": "العودة إلى الحجز",
  "Bag": "حقيبة",
  "BAG": "حقيبة",
  "Bag ID": "رقم الحقيبة",
  "Bag ID:": "رقم الحقيبة:",
  "Baggage Details": "تفاصيل الأمتعة",
  "Baggage-Info-Breakdown": "سيتم عرض تفاصيل الأمتعة فور استلامها​",
  "Extra-Bags-Payment-Confirmed": "قد تكون بعض الحقائب قد أُضيفت أثناء الاستلام بعد تأكيد الدفع.",
  "Baggage added successfully": "تمت إضافة الأمتعة بنجاح",
  "Your booking has been updated to include the additional baggage.": "تم تحديث حجزك ليشمل الأمتعة الإضافية.",
  "Baggage changes are unavailable as your selected pickup slot is coming up.": "لا يمكن تعديل الأمتعة حيث اقترب موعد الاستلام الذي اخترته.",
  "Baggage updated": "تم تحديث الأمتعة",
  "Bags": "أمتعة",
  "Bags added successfully": "تمت إضافة الحقائب بنجاح",
  "Bags after update": "عدد الحقائب بعد التحديث",
  "Bar code:": "الرمز التسلسلي",
  "Barcode:": "الباركود:",
  "Barcode should be 10 to 15 characters long.": "يجب أن يتكون الرمز الشريطي من ١٠ إلى ١٥ حرفًا.",
  "Could not save the bag. Please try again.": "تعذر حفظ الحقيبة. يرجى المحاولة مرة أخرى.",
  "This bag tag is already used.": "رقم بطاقة الحقيبة مستخدم بالفعل.",
  "barcode_numeric_length_error": ".يجب أن يكون الرمز الشريطي رقميًا ويحتوي على ما بين ١٠ و١٥ رقمًا",
  "Base Price": "السعر الأساسي",
  "Base Price:": "السعر الأساسي:",
  "Birth Date": "تاريخ الميلاد",
  "Birth Date is required": "تاريخ الميلاد مطلوب",
  "Book Services": "حجز الخدمات",
  "Book a service": "احجز خدمة",
  "Booking": "الحجز",
  "Booking Created Successfully": "تم إنشاء الحجز بنجاح",
  "Booking Details": "تفاصيل الحجز",
  "Booking ID": "رقم تعريف الحجز",
  "Booking ID:": "رقم الحجز :",
  "Booking QR code": "حجز رمز الاستجابة السريعة",
  "Booking Summary": "ملخص الحجز",
  "Booking Tracking": "سجل التتبع للحجز​",
  "Booking Type": "نوع الحجز",
  "Booking Update": "",
  "Booking Updated Successfully": "تم تحديث الحجز بنجاح",
  "Booking confirmed successfully": "تم تاكيد الحجز بنجاح",
  "Booking has been cancelled successfully!": "!تم إلغاء الحجز بنجاح",
  "Booking has been changed successfully!": "!تم تغيير الحجز بنجاح",
  "Booking service has been changed successfully!": "تم تغيير خدمة الحجز بنجاح!",
  "Booking/Left Behind ID": "معرّف الحجز/المتروك",
  "Bookings": "حجوزاتي",
  "Building": "مبنى",
  "Building:": "مبنى: ",
  "Business": "الأعمال",
  "CA": "كندا",
  "CANCEL": "الغاء",
  "CC": "جزر كوكوس",
  "CD": "الكونغو الديمقراطية",
  "CF": "جمهورية أفريقيا الوسطى",
  "CG": "الكونغو",
  "CH": "سويسرا",
  "CI": "ساحل العاج",
  "CK": "جزر كوك",
  "CL": "تشيلي",
  "CM": "الكاميرون",
  "CN": "الصين",
  "CO": "كولومبيا",
  "CONFIRM OPTION": "تأكيد الخيار",
  "CONTINUE WITH BOOKING": "متابعة الحجز",
  "CR": "كوستاريكا",
  "Credits": "الرصيد",
  "CU": "كوبا",
  "CV": "الرأس الأخضر",
  "CX": "جزيرة كريسماس",
  "CY": "قبرص",
  "CZ": "التشيك",
  "Call support": "رقم الهاتف",
  "Cancel": "إلغاء",
  "Cancel Booking": "إلغاء الحجز",
  "Cancel Booking?": "إلغاء الحجز؟",
  "Cancelled": "تم الإلغاء",
  "Card Holder Name": "اسم حامل البطاقة",
  "Card Holder Name:": "اسم حامل البطاقة:",
  "Card Number": "رقم البطاقة",
  "Card Number:": "رقم البطاقة:",
  "Change": "تغيير",
  "Change Language": "تغيير اللغة",
  "Change Language To:": "تغيير اللغة إلى:",
  "Change Payment Method": "تغيير طريقة الدفع",
  "Change Service": "تغيير الخدمة",
  "Change address": "تغيير العنوان",
  "Change service is not possible for this booking type": "تغيير الخدمة غير ممكن لنوع هذا الحجز",
  "Check-out Desk": "مكتب الاستلام",
  "Checked In": "تم الإيداع",
  "Checked-in bags": "الحقائب المودعة",
  "Choose your preferred language": "قم بإختيار لغتك المفضلة",
  "City": "مدينة",
  "City:": "المدينة :",
  "Class": "الفئة",
  "Close": "اغلق",
  "Coming to pickup": "في الطريق للاستلام",
  "Complete your baggage service booking for your": "أتمم حجز خدمة الأمتعة الخاصة برحلتك",
  "Completed": "مكتمل",
  "Confirm": "تأكيد",
  "Confirm Option": "تأكيد الخيار",
  "Confirm Booking": "تأكيد الحجز",
  "Confirm Booking Creation": "تأكيد إنشاء الحجز",
  "Confirm Password": "تأكيد كلمة المرور",
  "Confirm drop-off location": "تأكيد موقع الاستلام",
  "Confirm password is required": "تأكيد كلمة المرور مطلوب",
  "Confirm removal": "تأكيد الإزالة",
  "Confirm_Booking_Creation_Details": "يرجى التأكيد إذا كنت ترغب في متابعة إنشاء الحجز بالتفاصيل المقدمة. انقر على العودة إذا كنت تريد إعادة التحقق.",
  "Confirmed": "تم التاكيد",
  "Contact": "الاتصال",
  "Contact #": "رقم التواصل",
  "Contact Artaah Support": "تواصل مع دعم {{ appName }}",
  "Contact Support": "اتصل بالدعم",
  "Choose a Baggage Service": "اختر خدمة أمتعة",
  "Contact Us": "اتصل بنا",
  "Continue": "متابعة",
  "Continue with New Booking": "المتابعة بحجز جديد",
  "Continue to payment": "المتابعة إلى الدفع",
  "Current bags": "عدد الحقائب الحالي",
  "Copy": "نسخ",
  "Count": "عدد",
  "Country Code": "مفتاح الدولة",
  "Create Booking": "حجز جديد",
  "Customer Name": "اسم العميل",
  "Customer Signature": "توقيع العميل",
  "D to D delivery breakdown": "بكل بساطة، من باب منزلك الى باب وجهة الوصول، لا تقلق من ثقل امتعتك و حملها و توصيلها! فنحن نهتم بأمتعتك وسافر مرتاح بسهوله.",
  "DE": "ألمانيا",
  "DJ": "جيبوتي",
  "DK": "الدنمارك",
  "DM": "دومينيكا",
  "DO": "جمهورية الدومينيكان",
  "DZ": "الجزائر",
  "Dashboard": "الرئيسية",
  "Date": "التاريخ",
  "Date of Birth": "تاريخ الميلاد",
  "Debit/Credit Card": "بطاقة الائتمان/الخصم",
  "Delete": "حذف",
  "Delete Account": "حذف الحساب",
  "Delete Address": "حذف العنوان",
  "Delete Photo": "حذف الصورة",
  "Deliver to my address": "التوصيل إلى عنواني",
  "Delivered": "تم التسليم",
  "Delivering": "قيد التوصيل",
  "Delivering to customer": "التسليم إلى العميل",
  "Delivering to you": "في الطريق اليك",
  "Delivery Method": "طريقة التوصيل",
  "Departure Airport": "مطار المغادرة",
  "Didn't get it?": "لم يصلك الرمز؟",
  "Didn't receive the OTP yet?": "لم يصلك رقم المصادقة؟",
  "Discount": "الخصم",
  "Discount:": "الخصم:",
  "Dismiss": "الغاء",
  "Done": "تم",
  "Don't Contact the customer": "رجاء لا تتواصل مع العميل",
  "Don’t have an account?": "ليس لديك حساب؟",
  "Door To Airport": "من الباب إلى المطار",
  "Door To Door": "من الباب إلى الباب",
  "Door to door luggage delivery": "استلام و توصيل امتعتك من الباب للباب",
  "Door-Check-in-Service-Breakdown": "استمتع بخدمة استلام أمتعتك من موقعك وتوصيلها إلى وجهتك بكل سهولة وراحة، دون أي عناء.",
  "Door-To-Door": "من الباب إلى الباب",
  "Door-to-Airport - Departure Service": "من الباب إلى المطار - خدمة المغادرة",
  "Driver Arrived": "وصل السائق",
  "Driver Details": "تفاصيل السائق",
  "Driver details will appear here once the booking is assigned": "ستظهر تفاصيل السائق هنا بمجرد تخصيص الحجز",
  "Driver name": "اسم السائق",
  "Driver phone": "رقم هاتف السائق",
  "Driver phone is not available": "رقم هاتف السائق غير متاح حاليا",
  "Details": "التفاصيل",
  "Driver Tracking Ended": "انتهى تتبع السائق",
  "Drop-off Address": "عنوان التسليم",
  "Drop-off Details": "تفاصيل التسليم",
  "Drop-off Location": "مكان التسليم",
  "Drop-off location": "موقع التسليم",
  "Drop-off Slot": "موعد التسليم",
  "Drop-off slot": "موعد التسليم",
  "Drop-off Time": "وقت التسليم",
  "Drop-off slot has been updated successfully!": "قد تم تعديل مواعيد التوصيل",
  "Dropoff": "التسليم",
  "Dropoff Location": "مكان التسليم",
  "Dropoff location": "موقع التسليم",
  "Dropoff:": " التسليم: ",
  "Dropped To Arrival Desk": "تم التوصيل إلى مكتب الوصول",
  "Dropped To Departure Desk": "تم التوصيل إلى مكتب المغادرة",
  "Dropping to Airport": "التوصيل إلى المطار",
  "E-Ticket Number or Booking Reference Number": "رقم التذكرة أو رقم الحجز",
  "e.g. ABCD1234": "مثال ABCD1234",
  "E.g. SV1234": "مثال SV1234",
  "EC": "الإكوادور",
  "EE": "إستونيا",
  "EG": "مصر",
  "EH": "الصحراء الغربية",
  "EID - By card reader": "الهوية - عن طريق قارئ البطاقة",
  "EID Picture (Front and Back)": "صورة الهوية (أمامي وخلفي)",
  "END BOOKING PROCESS": "إنهاء الحجز",
  "ER": "إريتريا",
  "ES": "إسبانيا",
  "EST DELIVERY TIME :": "الوقت المتوقع للتوصيل :",
  "ET": "إثيوبيا",
  "ETA": "الزمن المتوقع للوصول:",
  "ETA Duration": "الوقت المتوقع للوصول",
  "Economy": "الاقتصاد",
  "Edit": "تعديل",
  "Edit Address": "تعديل العنوان",
  "Edit number of bags": "تعديل عدد الحقائب",
  "Edit Drop-off Slot": "عدل مواعيد التسليم",
  "Edit Pickup Slot": "عدل مواعيد استلام الامتعة",
  "Email": "البريد الإلكتروني",
  "Email / Phone Number": "البريد الالكتروني/ رقم الهاتف",
  "Email Address": "البريد الالكتروني",
  "Email is required": "البريد الإلكتروني مطلوب",
  "Email or Phone Number": "البريد الالكتروني او رقم الهاتف",
  "Email support": "البريد الالكتروني",
  "Empty-DropOff-Desc-Message": "نأسف لإعلامكم بعدم وجود فترات مناسبة لتسليم الأمتعة نسبة إلى البيانات المدخلة، فترات إستلام الأمتعة تعتمد على موعد وتاريخ إقلاع الراحلة مكان استلام/تسليم الأمتعة",
  "Empty-Pickup-Desc-Message": "نأسف لإعلامكم بعدم وجود فترات مناسبة لتسلم الأمتعة نسبة إلى البيانات المدخلة، فترات إستلام الأمتعة تعتمد على موعد وتاريخ إقلاع الراحلة مكان استلام/تسليم الأمتعة",
  "Bookings-Paused-Title": "تم إيقاف الحجوزات الجديدة مؤقتًا.",
  "Bookings-Paused-Description": "لسنا نستقبل حجوزات جديدة في الوقت الحالي، وقد يتغيّر ذلك قريبًا. يُرجى المراجعة لاحقًا للاطلاع على آخر التحديثات وتوفر الحجز.",
  "Bookings-Paused-Tagline": "رحلتك القادمة قد تكون على بعد نقرة واحدة فقط.",
  "English": "English",
  "National_Address_Hint": "إدخال العنوان الوطني لا يؤدي تلقائيًا إلى تحديث الموقع على الخريطة.",
  "Enter Bag ID": "أدخل رقم الحقيبة",
  "Enter Flight Date (Optional)": "أدخل تاريخ الرحلة (اختياري)",
  "Enter OTP to Access Your Booking": "أدخل رمز التحقق للوصول إلى حجزك",
  "Enter Your": "ادخل",
  "Enter Your Phone Number": "إدخل رقم الهاتف الخاص بك",
  "Enter flight code (E.g. SV1234)": "أدخل رقم الرحلة (مثال: SV١٢٣٤)",
  "Enter passenger email address": "إدخل البريد الإلكتروني للراكب",
  "Enter passenger first name": "إدخل اسم الراكب الأول",
  "Enter passenger last name": "إدخل اسم العائلة للراكب",
  "Enter the 6-digit code": "أدخل الرمز المكون من 6 أرقام",
  "Enter the OTP": "ادخل رقم التحقق",
  "Enter the code we sent to you": "ادخل الرقم المرسل اليك",
  "Error": "خطأ",
  "Ex. drop with the security...": "مثال، مراعاة الحذر في انزال الامتعة ...",
  "Experience. Seamless. Travelling": "عش تجربة السفر",
  "Experience. Seamless. Travelling breakdown": "السفر بعد أرتاح تغير و لن يعود ابدا كما كان. استخدم اكثر خدمة متطورة و مميزة .في عالم السفر",
  "Expired": "إنتهت فترة الصلاحية",
  "FAQs": "الأسئلة الشائعة",
  "FI": "فنلندا",
  "FJ": "فيجي",
  "FK": "جزر فوكلاند",
  "FM": "ميكرونيزيا",
  "FO": "جزر فارو",
  "FR": "فرنسا",
  "Failed": "فشل",
  "Failed Delivery": "فشل في التسليم",
  "Failed to deliver": "فشل التوصيل",
  "Female": "انثى",
  "File size must not exceed 10 MB.": "يجب ألا يتجاوز حجم الملف 10 ميجابايت.",
  "Fill in the address details below": "أدخل تفاصيل العنوان أدناه",
  "First": "الأول",
  "First Name": "الإسم الأول",
  "First Name is required": "الاسم الاول مطلوب",
  "First name is required": "الاسم الاول مطلوب",
  "Flight Code": "رمز الرحلة",
  "Flight Code:": "رمز الرحلة:",
  "Flight Details": "تفاصيل الرحلة",
  "Flight Number": "رقم الرحلة",
  "Flight Not Found": "لم يتم العثور على الرحلة",
  "Flight code": "رمز الرحلة",
  "Floor": "الطابق",
  "Floor Number": "رقم الطابق",
  "Floor Number(Optional)": "رقم الطابق (إختياري)",
  "Floor:": "الطابق: ",
  "Forgot Password?": "نسيت كلمة المرور؟",
  "GA": "الغابون",
  "GB": "المملكة المتحدة",
  "GD": "غرينادا",
  "GE": "جورجيا",
  "GF": "غيانا الفرنسية",
  "GG": "غيرنزي",
  "GH": "غانا",
  "GI": "جبل طارق",
  "GL": "غرينلاند",
  "GM": "غامبيا",
  "GMT": "غرينتش",
  "GN": "غينيا",
  "GO BACK": "الرجوع للخلف",
  "GP": "جوادلوب",
  "GQ": "غينيا الاستوائية",
  "GR": "اليونان",
  "GS": "جورجيا الجنوبية وجزر ساندويتش الجنوبية",
  "GT": "غواتيمالا",
  "GU": "غوام",
  "GW": "غينيا بيساو",
  "GY": "غيانا",
  "Gender": "الجنس",
  "Get Flight Details": "اظهار تفاصيل الرحلة",
  "Get In Touch": "اتصل بنا",
  "Knowledge Base": "قاعدة المعرفة",
  "Go Back": "الرجوع للخلف",
  "HIGHLY SATISFIED": "راض للغاية",
  "HK": "هونغ كونغ",
  "HM": "جزيرة هيرد وجزر ماكدونالد",
  "HN": "هندوراس",
  "HR": "كرواتيا",
  "HT": "هايتي",
  "HU": "المجر",
  "Have an account already?": "هل لديك حساب بالفعل؟",
  "Haven’t Received the code yet?": "لم يصلك رمز التحقق ؟",
  "Hi": "مرحباً",
  "Hint:": "تلميح:",
  "Home": "المنزل",
  "How can we do better in the next times? (Optional)": "كيف يمكننا تحسين أدائنا في الأوقات القادمة؟ (اختياري)",
  "How was your booking?": "كيف كان حجزك؟",
  "How would you like to pay?": "كيف تود الدفع؟",
  "I accept": "موافق",
  "I confirm that the information provided is accurate to the best of my knowledge. I understand that {{ appName }} and the airline are not responsible for discrepancies resulting from inaccurate or incomplete information provided during booking.": "أؤكد أن المعلومات المقدمة صحيحة ودقيقة حسب أفضل ما لدي من معرفة. وأفهم أن {{ appName }} وشركة الطيران غير مسؤولين عن أي اختلافات أو أخطاء ناتجة عن تقديم معلومات غير دقيقة أو غير مكتملة أثناء عملية الحجز.",
  "It’s time to pay": "حان وقت الدفع",
  "I want to pay later": "أريد الدفع لاحقاً",
  "I will pick it myself": "سوف احضر بنفسي للاستلام",
  "ID": "إندونيسيا",
  "IE": "أيرلندا",
  "IL": "إسرائيل",
  "IM": "جزيرة مان",
  "IMPORTANT!": "هام!",
  "IN": "الهند",
  "IO": "إقليم المحيط الهندي البريطاني",
  "IQ": "العراق",
  "IR": "إيران",
  "IS": "آيسلندا",
  "IT": "إيطاليا",
  "Identification": "رمز التعريف",
  "Identification Number": "رقم المستند",
  "Identification Type": "نوع المستند",
  "In Airport Pickup": "في استلام المطار",
  "In Flight": "في الرحلة",
  "In Pickup": "في الاستلام",
  "In Transit": "في الطريق",
  "Incorrect OTP code.": "رقم تحقق غير صحيح",
  "Invalid E-Ticket Number. Please ensure it contains only digits": "رقم التذكرة الإلكترونية غير صالح. يرجى التأكد من أنه يحتوي على أرقام فقط",
  "Invalid E-ticket number or Booking Reference": "رقم التذكرة الإلكترونية غير صالح. يرجى التأكد من أنه يحتوي على أرقام فقط",
  "Invalid Value": "قيمة غير صالحة",
  "Invalid format, please make sure the file format is in .png, .jpg, or .jpeg": "تنسيق غير صالح ، يرجى التأكد من أن تنسيق الملف بتنسيق .png أو .jpg أو .jpeg",
  "Invoice": "الفاتورة",
  "Invoices": "الفواتير",
  "JE": "جيرزي",
  "JM": "جامايكا",
  "JO": "الأردن",
  "JP": "اليابان",
  "KE": "كينيا",
  "KG": "قيرغيزستان",
  "KH": "كمبوديا",
  "KI": "كيريباس",
  "KM": "جزر القمر",
  "KN": "سانت كيتس ونيفيس",
  "KP": "كوريا الشمالية",
  "KR": "كوريا الجنوبية",
  "KW": "الكويت",
  "KY": "جزر كايمان",
  "KZ": "كازاخستان",
  "Kg": " كيلوجرام",
  "LA": "لاوس",
  "LB": "لبنان",
  "LC": "سانت لوسيا",
  "LI": "ليختنشتاين",
  "LK": "سريلانكا",
  "LR": "ليبيريا",
  "LS": "ليسوتو",
  "LT": "ليتوانيا",
  "LU": "لوكسمبورغ",
  "LUGGAGE IS HERE!": "لقد وصلت امتعتك!",
  "LUGGAGE-ARRIVAL-INSTRUCTIONS-KEY": "لقد وصل سائق ارتاح للتو، يرجى مقابلته لاستلام امتعتك",
  "LV": "لاتفيا",
  "LY": "ليبيا",
  "Last Name": "إسم العائلة",
  "Last Name is required": "اسم العائلة مطلوب",
  "Last name is required": "اسم العائلة مطلوب",
  "Latitude": "خط الطول",
  "Let us know how was your experience of booking with Artaah?": "دعنا نعرف كيف كانت تجربتك مع {{ appName }}",
  "Let's add your checked-in bags": "دعنا نضيف حقائبك",
  "Let's add your dropoff location": "اختيار موقع لتسليم الامتعة",
  "Let's add your pickup location": "اختيار موقع استلام الامتعة",
  "Let's retrieve flight details": "تفاصيل الرحلة",
  "Let's verify it's you": "لنتحقق من هويتك",
  "Lets have a last look at your booking": "لطفا قم بتأكيد البيانات لتنفيذ الحجز​",
  "Link Expired:": "انتهت صلاحية الرابط:",
  "Live Location": "الموقع الحالي",
  "Login": "سجل الدخول",
  "Login your account": "تسجيل الدخول إلى حسابك",
  "Logout": "تسجيل الخروج",
  "Log Out": "تسجيل الخروج",
  "Longitude": "خط العرض",
  "Luggage": "الأمتعة",
  "Luggage Checkin": "تسجيل الحقائب",
  "Luggage Checkout": "تسليم الحقائب",
  "Luggage Delivery": "توصيل الحقائب",
  "Luggage Live Location": "الموقع الحالي للحقائب",
  "Luggage Pickup": "إستلام الحقائب",
  "Luggage Transit": "نقل الحقائب",
  "MA": "المغرب",
  "MC": "موناكو",
  "MD": "مولدوفا",
  "ME": "الجبل الأسود",
  "MF": "سانت مارتن",
  "MG": "مدغشقر",
  "MH": "جزر مارشال",
  "MK": "مقدونيا",
  "ML": "مالي",
  "MM": "ميانمار",
  "MM/DD/YYYY (e.g., 04/28/1990)": "شهر/يوم/سنة (مثال: ٠٤/٢٨/١٩٩٠)",
  "MN": "منغوليا",
  "MO": "ماكاو",
  "MP": "جزر ماريانا الشمالية",
  "MQ": "مارتينيك",
  "MR": "موريتانيا",
  "MS": "مونتسرات",
  "MT": "مالطا",
  "MU": "موريشيوس",
  "MV": "جزر المالديف",
  "MW": "مالاوي",
  "MX": "المكسيك",
  "MY": "ماليزيا",
  "MZ": "موزمبيق",
  "Make sure picture is clear": "تأكد من أن الصورة واضحة",
  "Male": "ذكر",
  "My Profile": "الملف الشخصي",
  "Name": "الاسم",
  "N/A": "غير متوفر",
  "NA": "ناميبيا",
  "NC": "كاليدونيا الجديدة",
  "NE": "النيجر",
  "NF": "جزيرة نورفولك",
  "NG": "نيجيريا",
  "NI": "نيكاراغوا",
  "NL": "هولندا",
  "NO": "النرويج",
  "NORMAL": "عادي",
  "NOT GOOD": "ليس جيدا",
  "NP": "نيبال",
  "NR": "ناورو",
  "NU": "نيوي",
  "NZ": "نيوزيلندا",
  "Name cannot exceed 30 characters.": "لا يمكن أن يتجاوز الاسم 30 حرفًا.",
  "National Address": "العنوان الوطني",
  "National Address Code": "رمز العنوان الوطني",
  "National Address:": "العنوان الوطني:",
  "Nationality": "الجنسية",
  "New": "حجز جديد",
  "New Booking": "حجز جديد",
  "New slot is held. Complete payment before it expires.": "تم حجز الموعد الجديد. أكمل الدفع قبل انتهاء الصلاحية.",
  "Next": "التالي",
  "No FAQs available": "لا توجد أسئلة شائعة متاحة",
  "No addresses added yet": "لا توجد عناوين محفوظة بعد",
  "No payment pending for this booking": "لا يوجد دفع معلق لهذا الحجز",
  "No payment required": "لا يوجد دفع مطلوب",
  "No drop-off slots are available. Please try again later.": "لا تتوفر مواعيد تسليم. يرجى المحاولة لاحقًا.",
  "No pickup slots are available. Please try again later.": "لا تتوفر مواعيد استلام. يرجى المحاولة لاحقًا.",
  "No slots available": "لا يوجد مواعيد متاحة",
  "No time slots are currently available. You may cancel or try again later.": "لا تتوفر مواعيد حاليًا. يمكنك الإلغاء أو المحاولة لاحقًا.",
  "No time slots are currently available for this booking. You may cancel this booking or try again later.": "لا توجد مواعيد متاحة حاليًا لهذا الحجز. يمكنك إلغاء الحجز أو المحاولة لاحقًا.",
  "Note": "ملاحظة",
  "Note cannot exceed 255 characters.": "لا يمكن أن تتجاوز الملاحظة ٢٥٥ حرفاً.",
  "Note cannot exceed 500 characters.": "لا يمكن أن يتجاوز الملاحظة ٥٠٠ حرف.",
  "Note: Please check your ticket to know your baggage allowance, the airline might charge you for any extra weight": "ملاحظة: يرجى التأكد من عدد ووزن الآمتعة المسموحة لك في رحلتك من خلال تفقد تفاصيل الرحلة، شركة الطيران قد تتطبق تكاليف اضافية في حالة وجود وزن زائد",
  "No. of bags": "عدد الحقائب",
  "Notes": "ملاحظة",
  "Number of Bags": "عدد الحقائب",
  "OK": "حسنا",
  "OM": "عمان",
  "ON THE WAY FOR DROPOFF": "في الطريق للتسليم",
  "OTP": "رمز التحقق",
  "OTP code is incorrect.": "رقم المصادقة غير صحيح",
  "OTP send": "تم إرسال رمز التحقق",
  "OTP will be sent to the selected number": "تم ارسال رقم المصادقة الى هاتفك",
  "OTP-instructions": "يرجى تأكيد بياناتك والتحقق من رقم هاتفك لمتابعة عملية التسليم",
  "OTP-instructions-2": "دعنا نضيف تفاصيلك حتى يمكن توصيلها في أقرب وقت ممكن.",
  "OTP-instructions-3": "نحتاج للتحقق من رقم هاتفك أولاً",
  "verify-otp-phone-subtitle": "سنرسل رمزاً مؤقتاً إلى {{ phone }}.",
  "verify-otp-privacy-note": "هذا يحافظ على خصوصية حجزك وعنوان التوصيل، ولا يظهر إلا لك ولـ {{ appName }}.",
  "verify-id-title": "أدخل {{ idType }}",
  "verify-id-subtitle": "نستخدم هذا للتحقق من هويتك قبل تسليم حقيبتك.",
  "verify-id-placeholder": "مثال: 192278507",
  "verify-bags-subtitle-singular": "حقيبتك المتروكة من {{ organization }} جاهزة لتحديد موعد التسليم.",
  "verify-bags-subtitle-plural": "حقائبك المتروكة من {{ organization }} جاهزة لتحديد موعد التسليم.",
  "verify-bags-count-singular": "{{ count }} حقيبة جاهزة",
  "verify-bags-count-plural": "{{ count }} حقائب جاهزة",
  "verify-bags-check-note": "يرجى مراجعة كل حقيبة قبل الاستمرار",
  "verify-bag-label": "حقيبة {{ number }}",
  "verify-bag-index": "{{ current }} من {{ total }}",
  "Delivery fee applies": "تُطبق رسوم توصيل",
  "I'll pick it up myself": "سأستلمها بنفسي",
  "no delivery fee.": "بدون رسوم توصيل.",
  "A delivery fee of": "رسوم توصيل بقيمة",
  "applies.": "مستحقة.",
  "Choose a baggage delivery slot": "اختر موعد توصيل الأمتعة",
  "Building / Villa": "المبنى / الفيلا",
  "Note for the driver": "ملاحظة للسائق",
  "Gate code, landmark, or delivery instructions": "رمز البوابة، معلم بارز، أو تعليمات التوصيل",
  "e.g. Al Olaya": "مثال: العليا",
  "e.g. 12": "مثال: 12",
  "e.g. 3": "مثال: 3",
  "e.g. Villa 41": "مثال: فيلا 41",
  "Off To Airport": "في طريقه إلى المطار",
  "Office/Hotel": "مكتب / فندق",
  "Office/Hotel Name or Number": "اسم أو رقم المكتب / الفندق",
  "Ok": "حسنا",
  "Optional": "إختياري",
  "Other": "أخرى",
  "Overview": "نظرة عامة",
  "Section": "قسم",
  "Out for delivery": "جاري التوصيل",
  "PA": "بنما",
  "PAY": "إدفع",
  "PE": "بيرو",
  "PF": "بولينيزيا الفرنسية",
  "PG": "بابوا غينيا الجديدة",
  "PH": "الفلبين",
  "PK": "باكستان",
  "PL": "بولندا",
  "PM": "سان بيير وميكلون",
  "PN": "بيتكيرن",
  "PNR": "رقم الحجز",
  "POWERED BY": "خدمة مقدمة من​",
  "PR": "بورتوريكو",
  "PROCEED": "التالي",
  "PS": "فلسطين",
  "PT": "البرتغال",
  "PW": "بالاو",
  "PY": "باراغواي",
  "Paid": "مدفوع و تم تأكيده​",
  "Passenger Information": "معلومات الراكب",
  "Passenger Name": "اسم الراكب",
  "Passport": "جواز السفر",
  "Passport Number": "رقم جواز السفر",
  "Password": "كلمة المرور",
  "Password is required": "كلمت السر مطلوبة",
  "Password reset successfully": "تم إعادة تعيين كلمة المرور بنجاح",
  "Password should be 8 characters or more": "كلمة المرور يجب ان تكون 8 احرف فاكثر",
  "Passwords do not match": "كلمات المرور غير متطابقة",
  "Pay Later": "الدفع لاحقاً",
  "Pay Now": "إدفع الأن",
  "Phone": "الهاتف",
  "Pay with Debit/Credit Card": "الدفع عن طريق بطاقة الائتمان/الخصم",
  "Payment": "المبلغ",
  "Price": "السعر",
  "Payment Details": "تفاصيل الدفع",
  "Payment Failed": "فشل الدفع",
  "Payment History": "تتبع الدفع",
  "Payment Link": "رابط الدفع",
  "Payment Pending": "في انتظار الدفع",
  "Payment Status": "حالة الدفع",
  "Payment Summary": "ملخص الدفع",
  "Payment failed, please try again": "فشل الدفع، يرجى المحاولة مرة أخرى",
  "Payment was not completed. Your original baggage quantity remains unchanged.": "لم تكتمل عملية الدفع. تبقى كمية الأمتعة الأصلية دون تغيير.",
  "Pending": "قيد الانتظار",
  "Pending Booking Details": "تفاصيل الحجز المعلق",
  "Pending Extra Booking Details": "في انتظار تفاصيل الحجز الإضافية",
  "Pending Payment": "في إنتظار الدفع",
  "Personal ID": "الهوية الشخصية",
  "Phone Number": "رقم الهاتف",
  "Pick-up Location": "مكان الاستلام",
  "Picking up from Airport": "يجري الاستلام من المطار",
  "Picking up from customer": "الاستلام من العميل",
  "Pickup": "الاستلام",
  "Pickup Address": "موقع استلام الامتعة",
  "Pickup Details": "تفاصيل الاستلام",
  "Pickup Slot": "موعد استلام الامتعة",
  "Pickup Time": "موعد استلام الامتعة",
  "Pickup Window": "نافذة الاستلام",
  "Pickup slot has been updated successfully!": "قد تم تعديل موعد استلام الامتعة",
  "Pickup:": " الاستلام: ",
  "Pickup location": "موقع الاستلام",
  "Pictures": "الصور",
  "Please add your bags before completing payment.": "يرجى إضافة حقائبك قبل إتمام الدفع.",
  "Please add your dropoff address to continue": "يرجى إضافة عنوان التسليم للمتابعة",
  "Please add your pickup address to continue": "يرجى إضافة عنوان الاستلام للمتابعة",
  "Please add your reason here": "الرجاء إضافة السبب الخاص بك هنا",
  "Please click on ": "قم بالضغط على ",
  "Please click on the button below to confirm your details": "الرجاء الضغط على الزر في الاسفل لتاكيد الحجز",
  "Please confirm the following points to proceed with the booking": "الرجاء الاجابة عن الاسئلة القادمة لمتابعة الحجز",
  "Please enter a valid email": "الرجاء ادخال عنوان بريد صحيح",
  "Please enter a valid phone number": "الرجاد ادخال رقم هاتف صالح",
  "Please enter the code you received": "يرجى إدخال الرمز الذي تلقيته",
  "Please enter the information to retrieve the flights": "الرجاء إدخال المعلومات لاستعادة الرحلات",
  "Please enter your bag ID": "الرجاء إدخال رقم حقيبتك",
  "Please enter your updated password": "يرجى إدخال كلمة المرور الجديدة",
  "Please make sure you have entered the valid information": "الرجاء التحقق من صلاحية المعلومات المدخلة",
  "Please select the slot for pick from the pickup location": "الرجاء اختيار موعد استلام الأمتعة من موقع الاستلام",
  "Please select the slot for drop off at the dropoff location": "الرجاء اختيار موعد تسليم الأمتعة في موقع التسليم",
  "Please select the slot to drop your luggage at the below location": "الرجاء اختيار مواعيد التوصيل",
  "Please select your preferred option to deliver your luggage": "الرجاء تحديد خيارك المفضل لتسلم أمتعتك",
  "Please confirm using OTP or your password to continue.": "يرجى التأكيد باستخدام رمز OTP أو كلمة المرور للمتابعة.",
  "Please verify your email": "يرجى التحقق من بريدك الإلكتروني",
  "Please verify your phone number": "الرجاء توثيق رقم الهاتف",
  "Please review them before proceeding to select your baggage service.": "يرجى مراجعتها قبل المتابعة لاختيار خدمة الأمتعة.",
  "We'll use your mobile number to send booking updates and provide secure access to your tracking link.": "سنستخدم رقم هاتفك لإرسال تحديثات الحجز وتوفير وصول آمن لرابط التتبع.",
  "Please wait while we prepare your baggage service options.": "يرجى الانتظار بينما نقوم بتجهيز خيارات خدمة الأمتعة الخاصة بك.",
  "Please write your email address below": "يرجى كتابة عنوان بريدك الإلكتروني أدناه",
  "Please_ensure_your_selection_matches_your_ticket": "يرجى التأكد من أن اختيارك يتطابق مع تذكرتك.",
  "Please_enter_the_OTP_sent_to_your_registered_mobile_number/email_to_confirm": "يرجى إدخال رمز التحقق المرسل إلى رقم هاتفك المسجل أو بريدك الإلكتروني للتأكيد.",
  "Preparing your Booking": "جارٍ تجهيز حجزك",
  "Proceed": "التالي",
  "Proceed To Pay": "المتابعة للدفع",
  "Processing": "قيد التنفيذ",
  "Profile Details": "تفاصيل الحساب",
  "Prohibited goods": "البضائع المحظورة",
  "Proof Of Delivery": "إثبات التوصيل",
  "Proof Of Pickup": "إثبات الاستلام",
  "Proof Of Pickup / Delivery": "إثبات الاستلام / التوصيل",
  "Province": "مقاطعة",
  "QA": "قطر",
  "QR Code": "رمز الاستجابة السريعة",
  "QR-CODE-INSTRUCTION-KEY": "تحتاج إلى إظهار رمز الاستجابة السريعة هذا لممثل ارتاح بمجرد وصوله لتسليم أمتعتك",
  "RE": "روينيون",
  "RO": "رومانيا",
  "RS": "صربيا",
  "RU": "روسيا",
  "RW": "رواندا",
  "Re-type Password": "أعد كتابة كلمة المرور",
  "Re-upload": "إعادة الرفع",
  "Recover Password": "استعادة كلمة المرور",
  "Reference Key:": "مفتاح المرجع:",
  "Refund": "استرداد",
  "Refund Failed": "تم الإلغاء",
  "Refund In Progress": "يجري اعادة المبلغ حالياً",
  "Refund Method": "طريقة الاسترداد",
  "Refund Succeeded": "نجحت عملية اعادة المبلغ",
  "Refunded": "تم اعادة المبلغ",
  "Reselect Drop-off Slot": "إعادة اختيار موعد التسليم",
  "Reselect Pickup Slot": "إعادة اختيار موعد الاستلام",
  "Reselect Slot": "إعادة اختيار الموعد",
  "Reselect Slots": "إعادة اختيار المواعيد",
  "Register": " تسجيل حساب",
  "Register Account": "تسجيل حساب",
  "Reload?": "إعادة التحميل؟",
  "Remembered your password?": "هل تذكرت كلمة المرور؟",
  "Remove": "إزالة",
  "Remove Bag": "قم بإزالة الحقيبة",
  "Replace": "إستبدال",
  "Request OTP": "اطلب رقم المصادقة",
  "Request OTP code to proceed with the tracking link": "اطلب رمز التحقق للمتابعة عبر رابط التتبع",
  "Required": "مطلوب",
  "Required formats:": "الصيغ المطلوبة:",
  "Resend Code": "اعد ارسال الرمز",
  "Resend OTP": "إعادة إرسال الرمز السري؟",
  "Resend OTP in": "أعد إرسال رمز التحقق خلال",
  "Resend OTP?": "اعادة ارسال رقم المصادقة",
  "Resend code": "إعادة إرسال الرمز",
  "Reset Password": "إعادة تعيين كلمة المرور",
  "SA": "السعودية",
  "SAR": "ر.س",
  "SATISFIED": "راضي",
  "SB": "جزر سليمان",
  "SC": "سيشل",
  "SD": "السودان",
  "SE": "السويد",
  "SG": "سنغافورة",
  "SH": "سانت هيلينا",
  "SI": "سلوفينيا",
  "SJ": "سفالبارد ويان ماين",
  "SK": "سلوفاكيا",
  "SL": "سيراليون",
  "SM": "سان مارينو",
  "SN": "السنغال",
  "SO": "الصومال",
  "SR": "سورينام",
  "SS": "جنوب السودان",
  "ST": "ساو تومي وبرينسيبي",
  "SUBMIT FEEDBACK": "ارسل التقييم",
  "SV": "السلفادور",
  "SX": "سينت مارتن",
  "SY": "سوريا",
  "SZ": "إسواتيني",
  "Save": "حفظ",
  "Save As": "حفظ ك",
  "Save to address book": "احفظ في دفتر العناوين",
  "Scheduled": "تمت الجدولة",
  "Search": "بحث",
  "Search or Select Your Location": "ابحث عن موقعك أو حدده",
  "Select the bags you want to add": "اختر الحقائب التي تريد إضافتها",
  "Choose a delivery slot": "اختر موعد التوصيل",
  "Select a payment method": "اختر طريقة الدفع",
  "Select payment method": "اختر طريقة الدفع",
  "Select Drop-off Slot": "اختر مواعيد التوصيل",
  "Select Drop-off Slot:": "اختر مواعيد التوصيل:",
  "Select Dropoff Slot": "حدد موعد تسليم أمتعتك",
  "Select Flight": "إختر الرحلة",
  "Select Flight Date": "تاريخ الرحلة",
  "Select Language": "اختر لغتك",
  "Select Payment Method": "اختر طريقة الدفع",
  "Select Phone Number": "اختر رقم هاتفك",
  "Select Pickup Slot": "حدد موعد استلام الامتعة",
  "Select card type to proceed": "حدد نوع البطاقة للمتابعة",
  "Select gender": "اختر الجنس",
  "Selected Dropoff slot": "الموعد المختار للتسليم",
  "Selected Pickup Slot": "الموعد المختار لاستلام الامتعة",
  "Selected Service": "الخدمة المختارة",
  "Selected time slots may fill up quickly. Availability of the selected time slot is confirmed at the time of payment.": "قد تمتلئ المواعيد المختارة بسرعة. يتم تأكيد توفر الموعد المختار عند إتمام الدفع.",
  "Slot has been updated successfully!": "تم تحديث الموعد بنجاح!",
  "Slots are filling fast. Book the slot by paying soon to confirm.": "تمتلئ المواعيد بسرعة. أكمل الدفع في أقرب وقت لتأكيد حجزك.",
  "The time window has passed. Reselect a slot to continue.": "انتهت النافذة الزمنية. يرجى اختيار موعد جديد للمتابعة.",
  "The slot selected is not confirmed until booking is paid": "الموعد المختار غير مؤكد حتى يتم سداد قيمة الحجز",
  "Send Verification Code": "إرسل رمز التحقق",
  "Send me OTP": "إرسال رمز التحقق​",
  "Service": "الخدمة",
  "Status": "الحالة",
  "Pickup / Dropoff": "الاستلام / التسليم",
  "page_of_total": "صفحة {{page}} من {{total}}",
  "col_booking_id": "الرقم",
  "Service Type": "نوع الخدمة",
  "Service charges": "رسوم الخدمة",
  "Service:": "نوع الخدمة:",
  "Services": "خدماتنا",
  "Share": "مشاركة",
  "Show QR Code": "رمز الاستجابة السريعة",
  "Show less": "عرض أقل",
  "Show less slots": "عرض فترات أقل",
  "Show more": "عرض المزيد",
  "Show more slots": "عرض المزيد من الفترات",
  "Sign up": "سجّل",
  "Skip": "تخطي",
  "Something Went Wrong!!": "حدث خطأ ما!",
  "Something went wrong with your booking? (Optional)": "حدث خطأ ما في الحجز؟ (اختياري)",
  "Sorry Something is not right!": "نرجوا المعذرة، هناك شئ ما غير صحيح",
  "error_popup_title": "حدث خطأ من جانبنا",
  "error_popup_message": "هذا ليس خطأك ولم يتم حفظ أي شيء. عادةً ما تنجح إعادة المحاولة.",
  "Stages": "المراحل",
  "Status:": "حالة الحجز:",
  "Submit": "ادخل",
  "Success": "نجاح",
  "Support": "الدعم",
  "TC": "جزر تركس وكايكوس",
  "TD": "تشاد",
  "TF": "الأقاليم الجنوبية الفرنسية",
  "TG": "توغو",
  "TH": "تايلاند",
  "TJ": "طاجيكستان",
  "TK": "توكيلاو",
  "TL": "تيمور الشرقية",
  "TM": "تركمانستان",
  "TN": "تونس",
  "TO": "تونغا",
  "TR": "تركيا",
  "TT": "ترينيداد وتوباغو",
  "TV": "توفالو",
  "TW": "تايوان",
  "TZ": "تنزانيا",
  "Tag the Location": "تميز الموقع",
  "Task": "المهمة",
  "Thank you for your payment": "شكرًا لك على الدفع",
  "The Experience": "خدمة ارتاح",
  "The same barcode was added already, please use another barcode": "تمت إضافة نفس الرمز الشريطي من قبل، يرجى استخدام رمز شريطي آخر",
  "There is no amount to refund for this booking.": "لا يوجد مبلغ لاسترداده لهذه الحجز.",
  "This bag ID has already been added.": "معرّف الحقيبة هذا مستخدم بالفعل في حجز آخر.",
  "This bag ID is already used in another booking": "تمت إضافة معرّف الحقيبة هذا بالفعل",
  "Ticket Number": "رقم التذكرة",
  "Ticket number": "رقم التذكرة",
  "Travel class": "درجة السفر",
  "Select Date": "اختر التاريخ",
  "Flight Date": "تاريخ الرحلة",
  "Flight Departure": "مغادرة الرحلة",
  "Flight Arrival": "وصول الرحلة",
  "Excluding your carry-on baggage": "باستثناء حقيبة اليد",
  "Please place the code into the square": "ضع الرمز داخل المربع",
  "Ensure the barcode is fully visible before scanning": "تأكد من أن الباركود مرئي بالكامل قبل المسح",
  "flight": "رحلة",
  "flight_class_info_1": "تحرص {{ appName }} على تقديم تجربة سلسة لجميع المسافرين. يرجى اختيار درجة سفرك الفعلية حيث قد تتحقق شركات الطيران من هذا الاختيار.",
  "flight_class_info_2": "قد تؤثر الاختيارات غير الصحيحة على أهليتك للحصول على الخدمات المميزة.",
  "Pickup & Drop-off": "الاستلام والتسليم",
  "Pickup & Drop-off Times": "مواعيد الاستلام والتسليم",
  "Pickup slot": "موعد الاستلام",
  "Dropoff slot": "موعد التسليم",
  "Retrieve flight details": "استرداد تفاصيل الرحلة",
  "Get Flight": "بحث عن الرحلة",
  "Type of luggage delivery service you need?": "ما نوع خدمة توصيل الأمتعة التي تحتاجها؟",
  "Verify Email": "التحقق من البريد الإلكتروني",
  "Update password": "تحديث كلمة المرور",
  "Confirm your mobile number": "تأكيد رقم هاتفك المحمول",
  "Profile Information": "معلومات الملف الشخصي",
  "Account Information": "معلومات الحساب",
  "Verify": "تحقق",
  "Verify your location": "تحقق من موقعك",
  "Enter_your_National_Address_Alert_Box": "حدد أو ابحث عن موقعك على الخريطة، ثم تحقق من أن الدبوس يطابق موقع الاستلام الفعلي. قم بتعديل الدبوس إذا لزم الأمر قبل الحفظ.",
  "Verify Phone number": "التحقق من رقم الهاتف",
  "Verify your phone number": "التحقق من رقم هاتفك",
  "Time": "الزمن",
  "Time remaining:": "الوقت المتبقي:",
  "Time Spent": "الوقت المستغرق",
  "Time Zone": "المنطقة الزمنية",
  "To avoid confusion": "لتجنب الالتباس، يرجى اختيار نفس موعد الاستلام المستخدم في الحجز السابق.",
  "To change the language, the page will need to reload, and all unsaved changes will be lost.": "لتغيير اللغة، ستحتاج الصفحة إلى إعادة التحميل، وستُفقد جميع التغييرات غير المحفوظة.",
  "Together.. we are changing movement": "معا.. نصنع التغيير",
  "Total": "الاجمالي",
  "Total Amount": "المبلغ الإجمالي",
  "Total Bags": "العدد الكلي للحقائب",
  "Total Charges": "إجمالي التكلفة",
  "Total Passengers": "إجمالي الركاب",
  "Total amount": "المبلغ الإجمالي",
  "Total bag charges": "اجمالي رسوم الحقائب",
  "Total baggage charges": "إجمالي رسوم الأمتعة",
  "Total:": ":الاجمالي",
  "Track delivery breakdown": "ارتاح ونحن نهتم بنقل وتوصيل أمتعتك",
  "Tracking": "التتبع",
  "Tracking Ended": "انتهى التتبع",
  "Transaction ID": "معرّف المعاملة",
  "Travel Bags": "حقائب السفر",
  "Travel Class": "درجة السفر",
  "Try Again": "حاول مرة أخرى",
  "Type": "النوع",
  "UA": "أوكرانيا",
  "UG": "أوغندا",
  "UM": "جزر الولايات المتحدة البعيدة الصغرى",
  "UNSATISFIED": "غير راضٍ",
  "US": "الولايات المتحدة",
  "UY": "أوروغواي",
  "UZ": "أوزبكستان",
  "Unit": "الوحدة",
  "Unit Number": "رقم الوحدة",
  "Unit Number (Optional)": "رقم الوحدة (إختياري)",
  "Unit:": "الوحدة: ",
  "Unable to load location suggestions. Please try again.": "تعذر تحميل اقتراحات الموقع. يرجى المحاولة مرة أخرى.",
  "Unknown": "غير معروف",
  "Update": "تحديث",
  "Update Bag": "تحديث الحقيبة",
  "Update drop-off slot": "عدل زمن التسليم",
  "Update pickup slot": "عدل مواعيد استلام الامتعة",
  "Upload Photo": "تحميل الصورة الشخصية",
  "Upload Picture": "تحميل الصورة",
  "Updated total": "الإجمالي بعد التحديث",
  "Use My Credits": "إدفع من خلال رصيد التطبيق",
  "Username is required": "اسم المستخدم مطلوب",
  "Username or password incorrect.": "اما ان كلمت السر او اسم المستخدم خاطئة",
  "VA": "دولة الفاتيكان",
  "VAT": "الضريبة",
  "VAT Percentage:": "الضريبة ({{X}}%)",
  "VAT:": "الضريبة:",
  "VC": "سانت فينسنت والغرينادين",
  "VE": "فنزويلا",
  "VG": "جزر فيرجن البريطانية",
  "VI": "جزر فيرجن الأمريكية",
  "VN": "فيتنام",
  "VU": "فانواتو",
  "Valid email is required": "الرجاء إدخال بريد إلكتروني صالح",
  "Verification Code": "رمز التحقق",
  "Verify Code": "تحقق من الرمز",
  "Verify OTP": "التحقق من الرمز السري",
  "Version": "الاصدار",
  "View": "عرض",
  "View All": "الكل",
  "View Booking": "عرض الحجز",
  "View Booking Details": "عرض تفاصيل الحجز",
  "View Details": "عرض التفاصيل",
  "View Existing Booking": "عرض الحجز السابق",
  "View Invoice": "عرض الفاتورة",
  "View Invoices": "عرض الفواتير",
  "View More": "عرض المزيد",
  "View QR Code": "عرض رمز الاستجابة السريعة",
  "View all booking details and track them": " ",
  "View images": "عرض الصور",
  "View/Download": "عرض/تنزيل",
  "Villa": "فيلا",
  "Villa Name or Number": "اسم أو رقم الفيلا",
  "WF": "واليس وفوتونا",
  "WS": "ساموا",
  "Waiting for driver to send his updates": "في انتظار أن يرسل السائق تحديثاته",
  "We Found an Existing Booking": "لقد وجدنا حجزًا سابقًا",
  "We had an issue generating your QR code": "لقد تعذر انشاء رمز الاستجابة الخاص بهذا الحجز",
  "We sent you an otp to your phone number": "لقد قمنا بارسال رمز التحقق لهاتفك",
  "We're here to help you": "نحن هنا لمساعدتك",
  "What type of luggage delivery service you need?": "اختر نوع الخدمة المناسبة لك",
  "When do you want us to drop your luggage?": "اختر زمن التسليم",
  "When do you want us to pickup your luggage?": "اختر زمن الاستلام",
  "With baggage assistant": "مع مساعد الأمتعة",
  "Work": "العمل",
  "Wrong Identification Number": "{{idType}} غير صحيح",
  "YE": "اليمن",
  "YT": "مايوت",
  "You are back online!": "أنت متصل بالإنترنت مرة أخرى!",
  "You are offline. Check your internet connection.": "أنت غير متصل بالإنترنت. تحقق من اتصالك بالإنترنت.",
  "You don't have a booking tied to this identification number": "لايوجد لديك جحز قيد الاجراء",
  "You have": "لديك",
  "You have a booking pending": "لديك حجز قيد الانتظار",
  "You have a delivery pending": "لديك طلب في الانتظار",
  "You need to bring your Identification with you": "يجب عليك إحضار بطاقة الهوية معك",
  "You will be notified when the booking is out for pickup": "سوف نقوم باخطارك عندما يصبح طلبك في الطريق",
  "All scheduled time windows have passed. Create a new booking to continue.": "انتهت جميع النوافذ الزمنية المجدولة. يرجى إنشاء حجز جديد للمتابعة.",
  "Your Changes Have Been Saved Successfully": "لقد تم حفظ التغييرات بنجاح",
  "address_list_empty_hint": "قائمة عناوينك فارغة! يرجى إضافة عنوان جديد للمتابعة",
  "Your address has been deleted successfully": "تم حذف العنوان بنجاح",
  "Your bag ID has been updated!": "تم تحديث رقم حقيبتك!",
  "Your flight details have been securely imported from": "تم استيراد تفاصيل رحلتك بشكل آمن من",
  "Your reserved slot is no longer available. Please select a new one.": "الموعد المحجوز لم يعد متاحًا. يرجى اختيار موعد جديد.",
  "Your slot is held. Complete payment before the timer expires.": "تم حجز موعدك. أكمل الدفع قبل انتهاء العداد.",
  "Your slot is still available. Pay now to confirm it.": "موعدك لا يزال متاحًا. ادفع الآن لتأكيده.",
  "Your booking will be confirmed but payment will be required before service": "سيتم تأكيد حجزك ولكن سيُطلب منك الدفع قبل تقديم الخدمة",
  "Your booking has been created successfully!": "تم تاكيد حجزك بنجاح",
  "Your booking has been created. Please make the payment by clicking on the link or <b>“Pay Now”</b>": "“تم انشاء الحجز الخاص بك، يرجى إتمام عملية الدفع من خلال الضغط على الرابط في الأسفل أو ”ادفع الآن",
  "Your booking has been updated successfully!": "تم تحديث حجزك بنجاح",
  "Your booking has been updated. Please make the payment by clicking on the link or <b>“Pay Now”</b>": "“تم تحديث الحجز الخاص بك، يرجى إتمام عملية الدفع من خلال الضغط على الرابط في الأسفل أو ”ادفع الآن",
  "Your booking is cancelled. Please contact support for any queries.": "تم إلغاء حجزك. يرجى التواصل مع الدعم لأي استفسارات.",
  "Your fare is calculated based on the distance from the airport and the rates agreed with the airline.": "يتم احتساب أجرتك بناءً على المسافة من المطار والأسعار المتفق عليها مع شركة الطيران.",
  "Your ride": "رحلتك",
  "Your_boarding_pass_or_e-ticket_typically_includes_your_class": "عادةً ما تتضمن بطاقة الصعود إلى الطائرة أو التذكرة الإلكترونية درجة سفرك.",
  "ZA": "جنوب أفريقيا",
  "ZM": "زامبيا",
  "ZW": "زيمبابوي",
  "account.deactivate.action": "تعطيل الحساب",
  "account.deactivate.description": "سيتم تعطيل حسابك وتعليق الوصول إليه. يمكنك إعادة تفعيله في أي وقت بتسجيل الدخول مجدداً.",
  "account.deactivate.success": "تم تعطيل حسابك بنجاح. لإعادة التفعيل، سجّل الدخول باستخدام بياناتك المسجلة.",
  "account.deactivate.title": "تعطيل الحساب",
  "account.deactivated.loginBanner": "تم تعطيل حسابك.",
  "account.delete.availableAfter": "متاح بعد",
  "account.delete.blockedTitle": "تعذّر حذف الحساب",
  "account.delete.confirmCta": "تأكيد الحذف",
  "account.delete.continue": "متابعة",
  "account.delete.coolOffNotFinished": "يرجى الانتظار حتى انتهاء فترة التهدئة قبل تأكيد الحذف.",
  "account.delete.goToBookings": "الذهاب إلى الحجوزات",
  "account.delete.invalidOtp": "الرمز غير صحيح. يرجى المحاولة مجدداً.",
  "account.delete.irreversibleDescription": "سيتم حذف بياناتك الشخصية نهائياً وإخفاء هويتها. ستُحتفظ بسجلات الحجوزات والأمتعة والمدفوعات دون معرّفات شخصية. بعد التأكيد، تسري فترة تهدئة قبل اكتمال الحذف. هل أنت متأكد من رغبتك في حذف حسابك نهائياً؟",
  "account.delete.noPendingRequest": "لم يُعثر على طلب حذف. يرجى البدء من جديد.",
  "account.delete.pendingBanner": "سيكون حذف حسابك متاحاً بعد",
  "account.delete.pendingLabel": "حذف معلق",
  "account.delete.requested": "تم تقديم طلب الحذف. ستتمكن من التأكيد بعد انتهاء فترة التهدئة.",
  "account.delete.success": "تم حذف حسابك نهائياً.",
  "account.delete.title": "تأكيد حذف الحساب",
  "account.otp.sentTo": "لقد أرسلنا كلمة مرور لمرة واحدة (OTP) إلى هاتفك المنتهي بـ",
  "account.otp.verify": "تحقق وتابع",
  "account.otp.verifyIdentity": "نحتاج إلى التحقق من هويتك",
  "account.phone.alreadyInUse": "رقم الهاتف هذا مرتبط بحساب آخر بالفعل.",
  "account.phone.sameNumber": "يجب أن يكون الرقم الجديد مختلفاً عن رقم هاتفك الحالي.",
  "account.phone.unsupportedCountryCode": "رمز البلد هذا غير مدعوم. يرجى استخدام رقم مختلف.",
  "account.reactivate.emailSubtitle": "أدخل بريدك الإلكتروني لإعادة التفعيل",
  "account.reactivate.otpSentTo": "تم إرسال رمز OTP إلى",
  "account.reactivate.proceed": "متابعة",
  "account.reactivate.reactivateNow": "إعادة تفعيله الآن",
  "account.reactivate.success": "تم إعادة تفعيل حسابك بنجاح.",
  "account.reactivate.title": "إعادة تفعيل حسابك",
  "account.reactivate.verify": "تحقق",
  "account.reactivate.verifyTitle": "يرجى التحقق من بريدك الإلكتروني",
  "already have a booking": "لديك حجز مسبق لهذه الرحلة. سيتولى فريقنا تنسيق جميع الحقائب عبر سائق واحد.",
  "and": "و",
  "bagid_hint_info_message": "رقم الحقيبة نهائي ولا يمكن تعديله بعد الحفظ. يرجى التحقق قبل المتابعة.",
  "blocking.DeleteCustomerNotEligibleActiveBooking": "لا يمكن حذف حسابك لأن لديك حجزاً نشطاً. يرجى إكماله أو حله قبل طلب الحذف.",
  "blocking.DeleteCustomerNotEligiblePendingRefund": "لا يمكن حذف حسابك لأن لديك استرداداً معلقاً.",
  "blocking.DeleteCustomerNotEligibleUnpaidBooking": "لا يمكن حذف حسابك لأن لديك حجزاً غير مدفوع.",
  "blocking.DeleteCustomerNotEligibleUpcomingBooking": "لا يمكن حذف حسابك لأن لديك حجزاً قادماً.",
  "cancel_booking_info_message": "يمكنك إلغاء الحجز حتى تسعين دقيقة قبل وقت الاستلام أو التسليم الذي اخترته.",
  "cs_bags_hint": "يمكنك إضافة ما يصل إلى {{max}} حقيبة. يعتمد الوزن المسموح به الإجمالي على بدل الأمتعة في تذكرتك.",
  "cs_bag_count_hint": "ادفع الآن لحجز التوصيل لـ {{count}} حقيبة. أضف تفاصيل الحقائب لاحقاً.",
  "manage_bags_adding_hint": "إضافة {{count}} حقيبة. يتم تحديث الأمتعة فقط بعد اكتمال الدفع.",
  "manage_bags_adding_hint_one": "إضافة حقيبة واحدة. يتم تحديث الأمتعة فقط بعد اكتمال الدفع.",
  "manage_bags_removing_hint": "إزالة {{count}} حقيبة. لا يوجد استرداد أو رصيد تطبيق. لا يمكن التراجع عن هذا الإجراء.",
  "manage_bags_removing_hint_one": "إزالة حقيبة واحدة. لا يوجد استرداد أو رصيد تطبيق. لا يمكن التراجع عن هذا الإجراء.",
  "manage_bags_edit_hint": "استخدم – و + لتغيير عدد الحقائب. متاح حتى {{hours}} ساعات قبل موعد الاستلام.",
  "manage_bags_updated_total_hint": "تم تحديث حجزك إلى {{count}} حقيبة.",
  "manage_bags_updated_total_hint_one": "تم تحديث حجزك إلى حقيبة واحدة.",
  "bags_count": "{{count}} حقيبة",
  "By Passenger": "حسب الراكب",
  "By Bag": "حسب الحقيبة",
  "By PNR": "حسب رقم الحجز",
  "Bag Upload Progress": "تقدم رفع الحقائب",
  "Bag Upload Complete": "اكتمل رفع الحقائب",
  "Link URL": "رابط الدفع",
  "cm": " سم",
  "day(s)": "يوم / أيام",
  "distance_from_airport": "{{distance}} كم من مطار {{airport_code}}",
  "drop-off timing change note": "ملاحظة: قد تتغير مواعيد التسليم تبعا للتغيير في مواعيد الرحلة",
  "drop-off-note": "هذا الموعد يتطابق مع حجزك السابق لنفس الرحلة. سيتم توصيل الحقائب معًا.",
  "dropoff-slot-timezone-note": "تُعرض الأوقات بالتوقيت المحلي لمدينة خدمة التسليم ({{ offset }}).",
  "email": "البريد الإلكتروني",
  "hour(s)": "ساعة / ساعات",
  "if you still have an issue, contact our support team": "إذا استمرت المشكلة ، نرجوا الاتصال بفريق الدعم",
  "it should contain at least 1 lowercase character": "يجب ان تحتوي على 1 من الاحرف الصغيرة على الاقل",
  "it should contain at least 1 special letter": "يجب ان تحتوي على 1 من الحروف الخاصة على الاقل، مثال: $",
  "it should contain at least 1 uppercase character": "يجب ان تحتوي على 1 من الاحرف الكبيرة على الاقل",
  "km": "كم",
  "max size: 10 mb": "الحد الأقصى للحجم: 10 ميجابايت",
  "minute": "دقيقة",
  "minute(s)": "دقيقة / دقائق",
  "password": "كلمة المرور",
  "pick-up-note": "هذا الموعد يتطابق مع حجزك السابق لنفس الرحلة. سيتم جمع جميع الحقائب معًا.",
  "pickup-slot-timezone-note": "تُعرض الأوقات بالتوقيت المحلي لمدينة خدمة الاستلام ({{ offset }}).",
  "privacy policy": "سياسة الخصوصية",
  "rest for the session": "بقية الجلسة",
  "session-expires-in": "تنتهي الجلسة خلال {{ time }}",
  "second": "ثانية",
  "second(s)": "ثانية / ثواني",
  "seconds": "ثواني",
  "submit the code in:": "ادخل الكود قبل:",
  "terms & conditions": "الأحكام و الشروط",
  "try again": "حاول مرة اخرى",
  "unit: ": "الوحدة: ",
  "username_hint": "البريد الإلكتروني ({{email}}) الهاتف ({{phone}}+)",
  "Enter a valid email address": "أدخل بريدًا إلكترونيًا صالحًا",
  "Email or phone number is required": "البريد الإلكتروني أو رقم الهاتف مطلوب",
  "Enter a valid email or phone number": "أدخل بريدًا إلكترونيًا أو رقم هاتف صالحًا",
  "it should contain at least 1 number": "يجب أن تحتوي على رقم واحد على الأقل",
  "If an account exists for this email, we've sent a verification code to it. Please enter the code below.": "إذا كان هناك حساب مرتبط بهذا البريد الإلكتروني، فقد أرسلنا إليه رمز تحقق. يرجى إدخال الرمز أدناه.",
  "verification code": "رمز التحقق",
  "view_live_location_tooltip": "يمكنك تتبع السائق بمجرد أن يكون في طريقه إلى موقعك.",
  "year(s)": "سنة / سنوات",
  "|": "|",
  "العربية": "العربية",
  "No_Bookings_Title": "لا توجد حجوزات",
  "No_Bookings_Desc": "ليس لديك أي حجوزات حتى الآن. ابدأ بإنشاء حجز جديد.",
  "terms_consent_prefix": "لقد قرأت وأوافق على",
  "Terms and Conditions": "الشروط والأحكام",
  "Terms & Conditions": "الشروط والأحكام",
  "Privacy Policy": "سياسة الخصوصية",
  "invalid_booking_reference": "مرجع الحجز غير صحيح. يرجى إدخال رمز أبجدي رقمي مكون من 6 أحرف أو رقم تذكرة إلكترونية مكون من 15 رقماً",
  "invalid_total_passengers": "يجب أن يكون إجمالي عدد الركاب رقماً صحيحاً لا يقل عن 1",
  "Upload your bag details": "قم بتحميل تفاصيل حقيبتك",
  "The number of bags cannot be increased after payment.": "لا يمكن زيادة عدد الحقائب بعد الدفع.",
  "Please select the slot for pickup from your location": "يرجى اختيار الفترة لاستلام من موقعك",
  "Please select the slot for pick from the drop-off location": "يرجى اختيار الفترة للاستلام من موقع التسليم",
  "no_slots_available_desc": "نأسف لإبلاغك أنه لا توجد فترات متاحة للاستلام للمعلومات المقدمة",
  "no_dropoff_slots_available_desc": "نأسف لإبلاغك أنه لا توجد فترات متاحة للتسليم للمعلومات المقدمة",
  "All transactions for this booking": "جميع المعاملات لهذا الحجز",
  "Bag Barcode": "باركود الحقيبة",
  "Drop-off Window": "نافذة التسليم",
  "Flyplus": "فلاي بلس",
  "Artaah": "ارتاح",
  "CHATBOT.TITLE": "تحدث مع المساعد الذكي",
  "CHATBOT.SUBTITLE": "اسألني عن أي شيء يتعلق بحجزك",
  "CHATBOT.WELCOME_MESSAGE": "مرحباً! أنا مساعدك الذكي. يمكنني مساعدتك في:\n\n• معلومات الحجز وحالته\n• مواعيد الاستلام والتسليم\n• تفاصيل الدفع\n• تغييرات الخدمة\n• الاستفسارات العامة\n\nكيف يمكنني مساعدتك اليوم؟",
  "CHATBOT.PLACEHOLDER": "اكتب رسالتك...",
  "CHATBOT.TYPING": "المساعد الذكي يكتب...",
  "CHATBOT.ERROR_MESSAGE": "خطأ في الاتصال. يرجى التحقق من الإنترنت والمحاولة مرة أخرى.",
  "CHATBOT.NEW_CONVERSATION": "بدء محادثة جديدة",
  "CHATBOT.HISTORY": "سجل المحادثات",
  "CHATBOT.NO_CONVERSATIONS": "لا توجد محادثات سابقة",
  "CHATBOT.LOADING": "جارٍ الاتصال بالمساعد...",
  "CHATBOT.UNAVAILABLE": "المساعد الذكي غير متاح حاليًا. يرجى المحاولة لاحقًا.",
  "CHATBOT.VALIDATION_ERROR": "يرجى التحقق من رسالتك والمحاولة مرة أخرى.",
  "CHATBOT.NOT_FOUND_ERROR": "لم أتمكن من العثور على هذه المعلومات. يرجى التحقق من التفاصيل والمحاولة مرة أخرى.",
  "CHATBOT.TIMEOUT_ERROR": "يستغرق المساعد وقتًا أطول من المتوقع. يرجى المحاولة مرة أخرى.",
  "CHATBOT.RETRY": "إعادة المحاولة",
  "Security Upgrade Required": "مطلوب ترقية أمنية",
  "We've upgraded Artaah authentication and account security to align with the Fly+ identity platform. As part of this update, you're required to reset your password once before continuing. Your account details, bookings, and history remain unaffected.": "لقد قمنا بترقية مصادقة أرتاح وأمان الحساب لتتوافق مع منصة Fly+ للهوية. كجزء من هذا التحديث، يُطلب منك إعادة تعيين كلمة المرور مرة واحدة قبل المتابعة. تفاصيل حسابك وحجوزاتك وسجلك لم تتأثر.",
  "If you experience any issues, please contact support.": "إذا واجهت أي مشكلة، يرجى التواصل مع الدعم.",
  "Verify your email": "تحقق من بريدك الإلكتروني",
  "We sent a verification code to": "أرسلنا رمز التحقق إلى",
  "Didn't receive the code?": "لم تستلم الرمز؟",
  "Resend in": "إعادة الإرسال خلال",
  "Set New Password": "تعيين كلمة مرور جديدة",
  "Choose a strong password to secure your account.": "اختر كلمة مرور قوية لتأمين حسابك.",
  "New password": "كلمة المرور الجديدة",
  "Enter your new password": "أدخل كلمة مرورك الجديدة",
  "Confirm password": "تأكيد كلمة المرور",
  "Re-enter your new password": "أعد إدخال كلمة مرورك الجديدة",
  "Passwords do not match. Please re-enter your new password to confirm.": "كلمتا المرور غير متطابقتين. يرجى إعادة إدخال كلمة المرور الجديدة للتأكيد.",
  "Confirm Reset": "تأكيد الإعادة",
  "Minimum 8 characters required": "مطلوب 8 أحرف على الأقل",
  "Must include uppercase, number, and special character": "يجب أن تحتوي على حرف كبير ورقم وحرف خاص",
  "Help Center": "مركز المساعدة",
  "Policies": "السياسات",
  "Contact & Support": "التواصل والدعم",
  "Search FAQs": "البحث في الأسئلة الشائعة",
  "Clear search": "مسح البحث",
  "No FAQs found": "لم يتم العثور على أسئلة شائعة",
  "Failed to load FAQs. Please try again.": "فشل تحميل الأسئلة الشائعة. يرجى المحاولة مرة أخرى.",
  "No policies available": "لا توجد سياسات متاحة",
  "No support channels available": "لا توجد قنوات دعم متاحة",
  "Responds within": "يستجيب خلال",
  "Policy Details": "تفاصيل السياسة",
  "Effective": "ساري من",
  "On this page": "في هذه الصفحة",
  "current_language_name": "العربية",
  "Articles": "المقالات",
  "No articles available": "لا توجد مقالات متاحة",
  "Attachments": "المرفقات",
  "No PDFs attached.": "لا توجد ملفات PDF مرفقة.",
  "PDF": "PDF",
  "PDFs": "PDF",
  "Download": "تنزيل",
  "View PDF": "عرض PDF",
  "Live": "مباشر",
  "Updating...": "جارٍ التحديث...",
  "Reconnecting...": "إعادة الاتصال...",
  "Connection lost": "انقطع الاتصال",
  "Last updated {{time}}": "آخر تحديث {{time}}",
  "Updated {{time}}": "تم التحديث {{time}}",
  "just now": "الآن",
  "{{n}}s ago": "منذ {{n}} ثانية",
  "{{n}}m ago": "منذ {{n}} دقيقة",
  "Ready for pickup": "جاهز للاستلام",
  "You can collect your bag at the check-out desk shown below.": "يمكنك استلام حقيبتك من مكتب الاستلام الموضح أدناه.",
  "Delivery scheduled": "تم جدولة التسليم",
  "We'll notify you as your bag makes its way to you.": "سنُعلمك بمجرد أن تكون حقيبتك في طريقها إليك.",
  "Tracking page information": "معلومات صفحة التتبع",
  "Delivery location": "موقع التسليم",
  "Location confirmed": "تم تأكيد الموقع",
  "Self pick-up": "استلام ذاتي",
  "Desk:": "المكتب:",
  "Last updated": "آخر تحديث",
  "by": "بواسطة",
  "Delivery slot": "موعد التسليم",
  "Slot confirmed": "تم تأكيد الموعد",
  "No delivery slots are available right now.": "لا توجد مواعيد تسليم متاحة حاليًا.",
  "Save changes": "حفظ التغييرات",
  "View bag images": "عرض صور الحقيبة",
  "Bag images": "صور الحقيبة",
  "Compare these photos with the bag before scheduling or collecting it.": "قارن هذه الصور بالحقيبة قبل جدولة الاستلام أو استلامها.",
  "qr_caption_self_pickup": "أظهر رمز QR هذا عند مكتب الاستلام إذا كنت ستستلم حقيبتك شخصيًا.",
  "qr_caption_delivery": "أظهر رمز QR هذا للسائق عند وصوله ليتمكن من مسحه وتسليمك أمتعتك.",
  "Copy tracking link": "نسخ رابط التتبع",
  "locateMe": "تحديد موقعي",
  "Tracking link copied": "تم نسخ رابط التتبع",
  "Could not copy tracking link": "تعذر نسخ رابط التتبع",
  "EST Delivery time:": "الوقت المتوقع للتسليم:",
  "Agency Name": "اسم الوكالة",
  "Representative": "الممثل",
  "Departure Flight": "رحلة المغادرة",
  "Destination Address": "عنوان الوجهة",
  "Arrival Flight": "رحلة الوصول",
  "Upload New Bags": "رفع حقائب جديدة",
  "Multiple people can upload bags using this same link": "يمكن لعدة أشخاص رفع الحقائب باستخدام نفس هذا الرابط",
  "Added All Bags": "تمت إضافة جميع الحقائب",
  "Search...": "بحث...",
  "Add Passengers": "إضافة ركاب",
  "Room": "الغرفة",
  "Hotel Name": "اسم الفندق",
  "Bag Tag / Barcode": "بطاقة الحقيبة / الباركود",
  "Notes (Optional)": "ملاحظات (اختياري)",
  "No bags uploaded": "لم يتم رفع أي حقائب",
  "No passengers added yet.": "لم تتم إضافة أي ركاب بعد.",
  "No bags uploaded yet.": "لم يتم رفع أي حقائب بعد.",
  "Start by scanning or adding a new bag...": "ابدأ بمسح أو إضافة حقيبة جديدة...",
  "Start by adding a new passenger...": "ابدأ بإضافة راكب جديد...",
  "No passengers match your search.": "لا يوجد ركاب مطابقون لبحثك.",
  "No bags match your search.": "لا توجد حقائب مطابقة لبحثك.",
  "Add passenger": "إضافة راكب",
  "Tracking Not Available": "التتبع غير متاح",
  "No PNR groups found.": "لم يتم العثور على مجموعات حجز.",
  "{{ appName }} Booking Tracking": "تتبع حجز {{ appName }}",
  "tracking_otp_sent_title": "لقد أرسلنا رمز مرور لمرة واحدة (OTP).",
  "tracking_otp_enter_code_hint": "يرجى إدخال الرمز أدناه للوصول الآمن إلى حجزك.",
  "tracking_otp_code_expired": "انتهت صلاحية هذا الرمز. يرجى طلب رمز جديد.",
  "tracking_otp_invalid": "رمز التحقق غير صحيح. يرجى التحقق من الرمز والمحاولة مرة أخرى.",
  "Upload Bag Photo": "رفع صورة الحقيبة",
  "Drop photo here or click to upload": "أفلت الصورة هنا أو انقر للرفع",
  "Choose": "اختر",
  "Passenger name": "اسم الراكب",
  "Enter passenger name": "أدخل اسم الراكب",
  "Hotel name": "اسم الفندق",
  "Enter hotel name": "أدخل اسم الفندق",
  "E.g. 10": "مثال: 10",
  "Enter area name": "أدخل اسم المنطقة",
  "E.g. ABC123": "مثال: ABC123",
  "E.g. A12345678": "مثال: A12345678",
  "Bag Tag/Barcode": "بطاقة الحقيبة/الباركود",
  "E.g. 12345678910": "مثال: 12345678910",
  "Special instructions...": "تعليمات خاصة...",
  "Scan Barcode": "مسح الباركود",
  "Add Passenger Details": "إضافة تفاصيل الراكب",
  "example@email.com": "example@email.com",
  "E.g. 501234567": "مثال: 501234567",
  "Hotel": "الفندق",
  "Room Number": "رقم الغرفة",
  "E.g. 911": "مثال: 911",
  "Enter area": "أدخل المنطقة",
  "Add Passenger": "إضافة راكب",
  "All Bags Added Successfully!": "تمت إضافة جميع الحقائب بنجاح!",
  "You are about to mark this booking as complete.": "أنت على وشك تحديد هذا الحجز كمكتمل.",
  "Invite Collaborator": "دعوة متعاون",
  "Invite collaborators to add bags": "ادعُ المتعاونين لإضافة الحقائب",
  "Send Invitation": "إرسال الدعوة",
  "Invalid format. Use .png/.jpg/.jpeg": "صيغة غير صالحة. استخدم .png/.jpg/.jpeg",
  "Could not read the selected photo. Please try again.": "تعذر قراءة الصورة المحددة. يرجى المحاولة مرة أخرى.",
  "Upload failed: no URL returned": "فشل الرفع: لم يتم إرجاع رابط",
  "Upload failed": "فشل الرفع",
  "Please enter or scan the bag barcode.": "يرجى إدخال أو مسح باركود الحقيبة.",
  "Error Reading Barcode! Please Try Again.": "خطأ في قراءة الباركود! يرجى المحاولة مرة أخرى.",
  "Delete Bag": "حذف الحقيبة",
  "tracking-passengers-added-bags-count": "{{ completed }} من {{ total }} ركاب أضافوا حقائب",
  "tracking-bags-count": "الحقائب ({{ count }})",
  "tracking-bag-count-badge": "{{ count }} حقائب",
  "tracking-pnr-passenger-count-singular": "{{ count }} راكب",
  "tracking-pnr-passenger-count-plural": "{{ count }} ركاب",
  "tracking-otp-expires-in": "تنتهي الصلاحية خلال: {{ seconds }} ث",
  "tracking-confirm-delete-bag-description": "هل أنت متأكد أنك تريد حذف الحقيبة <strong>{{ code }}</strong>؟ لا يمكن التراجع عن هذا الإجراء.",
  "Your booking": "حجزك",
  "Individual": "فردي",
  "Group": "مجموعة",
  "Passenger": "الراكب",
  "Booking type": "نوع الحجز",
  "Estimated delivery": "التسليم المتوقع",
  "Show QR code": "عرض رمز QR",
  "passengers ready": "الركاب جاهزون",
  "Add your bags": "أضف حقائبك",
  "Invite someone to help": "ادعُ شخصًا للمساعدة",
  "Search by bag tag, PNR, or passenger": "ابحث ببطاقة الحقيبة أو رقم الحجز أو اسم الراكب",
  "Full name": "الاسم الكامل",
  "Passport number": "رقم جواز السفر",
  "Needs passport": "يتطلب جواز السفر",
  "Bag tag": "بطاقة الحقيبة",
  "Add a note (optional)": "أضف ملاحظة (اختياري)",
  "tracking-booking-subtitle": "#{{ id }} · تم الحجز بواسطة {{ agency }}",
  "tracking-booking-subtitle-id-only": "#{{ id }}",
  "tracking-add-bags-subtitle": "أدخل بيانات الراكب وأضف بطاقة لكل حقيبة. يمكن لأي شخص لديه هذا الرابط المساعدة؛ يتم حفظ التغييرات تلقائيًا.",
  "tracking-delivery-progress-subtitle": "{{ service }} · {{ status }}",
  "tracking_request_otp_hint": "اطلب رمز التحقق للمتابعة عبر رابط التتبع",
  "tracking_enter_otp_button": "أدخل رمز التحقق للوصول إلى حجزك",
  "live_tracking_subtitle": "تتبّع السائق في الوقت الفعلي",
  "current_language_short": "ع",
  "Delivery progress": "تقدّم التوصيل",
  "Flight": "الرحلة",
  "Selected service": "الخدمة المختارة",
  "invoices_dialog_subtitle": "جميع الفواتير الخاصة بهذا الحجز",
  "Ref:": "المرجع:",
  "Card Holder": "حامل البطاقة",
  "link_expired_message": "انتهت صلاحية هذا الرابط.",
  "tracking_load_passengers_failed": "تعذّر تحميل الركاب",
  "tracking_load_bags_failed": "تعذّر تحميل الحقائب",
  "tracking_load_pnr_list_failed": "تعذّر تحميل قائمة أرقام الحجز (PNR)",
  "E.g. AB1234": "مثال: AB1234",
  "slot-no-longer-available": "الموعد المحدد لم يعد متاحًا. يرجى اختيار موعد آخر.",
  "camera_access_required_title": "مطلوب الوصول إلى الكاميرا",
  "camera_access_required_message": "اسمح بالوصول إلى الكاميرا لمسح الرمز الشريطي للأمتعة.",
  "camera_access_blocked_hint": "إذا كان الوصول إلى الكاميرا محظورًا، فقم بتفعيله من أذونات الموقع في متصفحك، ثم حاول مرة أخرى.",
  "Enable Camera": "تفعيل الكاميرا",
  "Camera unavailable": "الكاميرا غير متاحة",
  "camera_unavailable_message": "تعذّر تشغيل الكاميرا على هذا الجهاز. يُرجى إدخال الرمز الشريطي يدويًا.",
  "pnr_format_error": "يجب أن يتكون رقم الحجز (PNR) من 6 أحرف بالضبط، باستخدام الحروف (A-Z) والأرقام (0-9) فقط، بدون مسافات أو رموز خاصة.",
  "PNR is required": "رقم الحجز (PNR) مطلوب",
  "recover_password_instruction": "أدخل بريدك الإلكتروني أو رقم هاتفك المسجل.",
  "Email or phone number": "البريد الإلكتروني أو رقم الهاتف",
  "Email or phone number is required": "البريد الإلكتروني أو رقم الهاتف مطلوب",
  "invalid_email_or_phone": "يرجى إدخال بريد إلكتروني أو رقم هاتف صالح.",
  "Terms and Conditions are not available yet": "الشروط والأحكام غير متاحة حاليًا",
  "We couldn't load the Terms and Conditions": "تعذّر تحميل الشروط والأحكام",
  "Retry": "إعادة المحاولة",
  "recover_password_code_sent": "إذا كان هناك حساب مرتبط بهذا البريد الإلكتروني أو رقم الهاتف، فقد أرسلنا إليه رمز تحقق. يرجى إدخال الرمز أدناه.",
  "id_number_letters_digits_only": "استخدم الحروف والأرقام فقط، بحد أقصى ٢٠ حرفًا",
  "National Address Code is required": "رمز العنوان الوطني مطلوب",
  "national_address_format_error": "استخدم ٤ أحرف متبوعة بـ ٤ أرقام (مثال: ABCD1234)",
  "ID:": "رقم الحجز:"
}
